import styled from '@emotion/styled';
import { Trash } from '@phosphor-icons/react';
import { Trans } from '@lingui/macro';
import { colors } from 'styles/theme/colors';

type ClearFieldButtonProps = {
  onClick: () => void;
  visible: boolean;
};

const CLEAR_BTN_CLASS = 'clear-field-btn';

export const ClearFieldButton = ({ onClick, visible }: ClearFieldButtonProps) => {
  if (!visible) return null;

  return (
    <Wrapper className={CLEAR_BTN_CLASS}>
      <Button type="button" onClick={onClick}>
        <Trash size={20} color={colors.error[400]} />
        <span>
          <Trans>Set empty</Trans>
        </span>
      </Button>
    </Wrapper>
  );
};

/**
 * Wrap an input + ClearFieldButton together so the button only appears
 * when the user focuses inside (input or button itself).
 */
export const ClearFieldFocusContainer = styled.div`
  & > .${CLEAR_BTN_CLASS} {
    display: none;
  }
  &:focus-within > .${CLEAR_BTN_CLASS} {
    display: block;
  }
`;

const Wrapper = styled.div`
  margin-top: 4px;
  width: 100%;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 10px 14px;
  border: 0.5px solid ${p => p.theme.palette.border.errorSolid};
  border-radius: 8px;
  background: ${p => p.theme.palette.bg?.primary ?? '#fff'};
  cursor: pointer;
  color: ${p => p.theme.palette.text.error};
  font-family: ${p =>
    p.theme.typography.bodyMd?.fontFamily ?? p.theme.typography.bodySm.fontFamily};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5rem;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;

  &:hover {
    background: ${p => p.theme.palette.bg.secondaryHover};
  }
`;
